"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._convertFSTOrderInfo = void 0;
const TradeUtils_1 = require("../TradeUtils");
function _convertFSTOrderInfo(value) {
    return {
        funding_fee: value.bu_order_data.funding_fee,
        fee: value.bu_order_data.fee,
        quote_amount: value.bu_order_data.quote_amount,
        quote_invest: value.bu_order_data.quote_invest,
        transfer_in: value.bu_order_data.transfer_in,
        transfer_out: value.bu_order_data.transfer_out,
        trx_24h: value.bu_order_data.trx_24h,
        profit: value.bu_order_data.profit,
        gridProfit: 0,
        totalProfit: 0,
        unRealizedProfit: 0,
        gridProfitPercent: 0,
        unrealizedProfitPercent: 0,
        totalProfitPercent: 0,
        portfolio: value.bu_order_data.portfolio.map((v) => {
            return {
                base: v.base,
                leverage: v.leverage,
                baseDisplay: TradeUtils_1.TradeUtils.parseBaseDisplay(v.base),
                side: v.side,
                mode: v.mode,
                qty_long: v.qty_long,
                qty_short: v.qty_short,
                amount_long: v.amount_long,
                amount_short: v.amount_short,
                amount_settle: v.amount_settle,
                maint_price: v.maint_price,
                tp_sl: v.tp_sl,
                hl_reach_price: v.hl_reach_price,
                hl_reach_ratio: v.hl_reach_ratio,
            };
        }),
    };
}
exports._convertFSTOrderInfo = _convertFSTOrderInfo;
